import { render } from "./OldXMLFileDIfference.vue?vue&type=template&id=4c84360c&scoped=true"
import script from "./OldXMLFileDIfference.vue?vue&type=script&lang=js"
export * from "./OldXMLFileDIfference.vue?vue&type=script&lang=js"

import "./OldXMLFileDIfference.vue?vue&type=style&index=0&id=4c84360c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c84360c"]])

export default __exports__